
const initialState = {
  school_year_id: null,
  school_grade_id: null,
  school_section_id: null,
  sections: [],
  subjects: [],
  schedules: {}
}

const scheduler = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_DATA':
      return action.payload

    case 'UPDATE_SECTION':
      return {
        ...state,
        school_section_id: action.payload
      }

    case 'UPDATE_SCHEDULES':
      return {
        ...state,
        schedules: {
          ...state.schedules,
          [action.payload.sectionId]: action.payload.schedules
        }
      };

    case 'REMOVE_DATA':
      return initialState;

    default:
      return state;
  }
};

export default scheduler;
